import {addAlert, AlertType} from "@web2/ap-alerts";

export const addErrorStatusAlert = (status: number) => addAlert({type: AlertType.ERROR, text: getErrorText(status)});

export const alertText = {
    error500Message: "Wystąpił błąd podczas przetwarzania operacji, prosimy powiadomić administratora aplikacji o zaistniałej sytuacji.",
    error504Message: "Czas oczekiwania na wykonanie operacji został przekroczony, prosimy powiadomić administratora aplikacji o zaistniałej sytuacji.",
    errorUnknownErrorMessage: "Wystąpił błąd podczas przetwarzania danych, prosimy spróbować później."
};

const getErrorText = (status: number) => {
    switch (status) {
        case 500:
            return alertText.error500Message;
        case 504:
            return alertText.error504Message;
        default:
            return alertText.errorUnknownErrorMessage;
    }
};
